const CHUNK_RELOAD_TIMESTAMP_KEY = 'chunkReloadTimestamp';
const CHUNK_RELOAD_THROTTLE_MS = 10000;

// Deploys replace hashed chunk files, so open sessions fail to lazy-load routes
// until refreshed. Recover with one automatic reload; the throttle prevents a
// reload loop when the failure persists (e.g. offline), letting the error throw
// instead so it stays visible in Sentry.
// preventDefault makes Vite resolve the failed import to undefined rather than
// reject, so lazy routes must go through lazyWithChunkRecovery, which suspends
// until the reload lands instead of crashing on the missing module.
// Complements usePageReloadOnFocus, which proactively refreshes tabs returning
// after long inactivity — this handles the failures that slip past it
export const registerChunkLoadRecovery = () => {
  window.addEventListener('vite:preloadError', (event) => {
    const lastReloadTime = Number(window.sessionStorage.getItem(CHUNK_RELOAD_TIMESTAMP_KEY)) || 0;

    if (Date.now() - lastReloadTime > CHUNK_RELOAD_THROTTLE_MS) {
      event.preventDefault();
      window.sessionStorage.setItem(CHUNK_RELOAD_TIMESTAMP_KEY, String(Date.now()));
      window.location.reload();
    }
  });
};
